import { render, staticRenderFns } from "./delayReduction.vue?vue&type=template&id=b7be2df4&scoped=true&"
import script from "./delayReduction.vue?vue&type=script&lang=js&"
export * from "./delayReduction.vue?vue&type=script&lang=js&"
import style0 from "./delayReduction.vue?vue&type=style&index=0&id=b7be2df4&scoped=true&lang=css&"
import style1 from "./delayReduction.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7be2df4",
  null
  
)

export default component.exports